import type { PropertyCardProps } from '@/components/PropertyCard';
import type { Imobiliaria, SiteImobiliaria } from '@/integrations/supabase/types';

/**
 * Dados mockados da imobiliária De Sordi Broker
 */
export const MOCK_IMOBILIARIA: Imobiliaria = {
  id: 'mock-imobiliaria-id',
  nome: 'De Sordi Broker',
  cnpj: '00.000.000/0000-00',
  email_login: 'contato@desordibroker.com.br',
  telefone: '19999999999',
  subdominio: 'desordibroker',
  status: 'ativo',
  url_site: 'https://desordibroker.com.br',
  permissoes: {
    modulo_anuncios: true,
    modulo_crm: true,
  },
  created_at: '2024-01-01T00:00:00Z',
  updated_at: '2024-01-01T00:00:00Z',
};

/**
 * Configurações mockadas do site
 */
export const MOCK_SITE_CONFIG: SiteImobiliaria = {
  id: 'mock-site-id',
  imobiliaria_id: 'mock-imobiliaria-id',
  status: 'publicado',
  ativo: true,
  publicado_em: '2024-01-01T00:00:00Z',
  usa_subdominio: true,
  dominio_personalizado: null,
  dominio_verificado: false,
  logo_url: '/logo-client.png',
  capa_url: '/banner-casa-1.png',
  banner_url: '/soul-photo.png',
  titulo_principal: 'Encontre seu imóvel ideal',
  texto_principal: 'Imóveis selecionados com qualidade e transparência',
  titulo_secundario: 'Por que escolher a De Sordi?',
  texto_secundario: 'Experiência, transparência e atendimento personalizado',
  titulo_terciario: null,
  texto_terciario: null,
  creci: 'CRECI 12345-J',
  email_contato: 'contato@desordibroker.com.br',
  telefone_contato: '5519996031818',
  instagram_url: 'https://instagram.com/desordibroker',
  carrossel_ativo: true,
  campanhas: null,
  configuracoes: {
    nome_site: 'De Sordi Broker',
    slogan: 'Seu próximo endereço está aqui',
    descricao_curta: 'Imobiliária especializada em imóveis residenciais e comerciais em Campinas',
    titulo_destaques: 'Imóveis em Destaque',
    subtitulo_destaques: 'Selecionados especialmente para você',
    titulo_sobre: 'A De Sordi Broker',
    descricao_sobre: 'Somos uma imobiliária de Campinas que acredita em atendimento próximo, imóveis bem selecionados e processos sem enrolação.',
    titulo_anuncie: 'Anuncie na De Sordi Broker',
    subtitulo_anuncie: 'Seu imóvel em destaque para quem está buscando de verdade',
    whatsapp: '5519982589820',
    whatsapp_mensagem_padrao: 'Olá! Vi um imóvel no site e gostaria de mais informações.',
    mostrar_mapa: true,
    mostrar_tour_virtual: true,
    mostrar_valores: true,
    meta_title: 'De Sordi Broker - Imóveis em Campinas',
    meta_description: 'Encontre os melhores imóveis em Campinas com a De Sordi Broker. Atendimento personalizado e imóveis selecionados.',
    meta_keywords: ['imóveis campinas', 'apartamentos', 'casas', 'imobiliária'],
    cor_primaria: '#D4AF37',
    cor_secundaria: '#1A1A1A',
    cor_destaque: '#F59E0B',
  },
  total_visitas: 1250,
  ultima_visita: '2024-01-15T10:30:00Z',
  created_at: '2024-01-01T00:00:00Z',
  updated_at: '2024-01-01T00:00:00Z',
};

/**
 * Imóveis mockados para demonstração
 */
export const MOCK_FEATURED_PROPERTIES: PropertyCardProps[] = [
  {
    id: 1,
    title: "Apartamento Studio Taquaral",
    price: "R$ 2.500",
    priceUnit: "/mês",
    additionalCosts: "+ condomínio e IPTU",
    address: "Rua das Palmeiras, 123 - Taquaral, Campinas - SP",
    image: "/img-default.jpg",
    saleType: "Locação",
    code: "00000000000000",
    type: "Studio",
    attributes: "1 quarto • 1 banheiro • 35m²",
    isNew: true,
    engagementCount: 24,
  },
  {
    id: 2,
    title: "Casa Residencial Barão Geraldo",
    price: "R$ 850.000",
    additionalCosts: "+ condomínio e IPTU",
    address: "Av. Albino J. B. de Oliveira, 800 - Barão Geraldo, Campinas - SP",
    image: "/img-default.jpg",
    code: "00000000000000",
    saleType: "Venda",
    type: "Casa",
    attributes: "3 quartos • 2 banheiros • 120m²",
    badges: [{ type: "featured", label: "Destaque" }],
  },
  {
    id: 3,
    title: "Apartamento Próximo UNICAMP",
    price: "R$ 1.800",
    priceUnit: "/mês",
    additionalCosts: "+ condomínio e IPTU",
    address: "Rua João Jorge, 200 - Cidade Universitária, Campinas - SP",
    image: "/img-default.jpg",
    saleType: "Locação",
    type: "Apartamento",
    code: "00000000000000",
    attributes: "2 quartos • 1 banheiro • 60m²",
    engagementCount: 12,
  },
  {
    id: 4,
    title: "Studio Mobiliado Centro",
    additionalCosts: "+ condomínio e IPTU",
    price: "R$ 1.200",
    priceUnit: "/mês",
    code: "00000000000000",
    address: "Rua Dr. Quirino, 500 - Centro, Campinas - SP",
    image: "/img-default.jpg",
    saleType: "Locação",
    type: "Studio",
    attributes: "1 quarto • 1 banheiro • 30m²",
    badges: [{ type: "partner", label: "HouseBit Studios" }],
  },
  {
    id: 5,
    title: "Apartamento Garden Cambuí",
    price: "R$ 3.200",
    priceUnit: "/mês",
    additionalCosts: "+ condomínio e IPTU",
    code: "00000000000000",
    address: "Rua Conceição, 1200 - Cambuí, Campinas - SP",
    image: "/img-default.jpg",
    saleType: "Locação",
    type: "Apartamento",
    attributes: "2 quartos • 2 banheiros • 80m²",
  },
  {
    id: 6,
    title: "Apartamento no Taquaral",
    price: "R$ 2.800",
    priceUnit: "/mês",
    additionalCosts: "+ condomínio e IPTU",
    address: "Rua do endereço, 000 - Campinas SP",
    image: "/img-default.jpg",
    saleType: "Locação",
    type: "Apartamento",
    code: "00000000000000",
    attributes: "72m² • 2 Quartos • 2 vagas",
    isNew: true,
    engagementCount: 12,
  },
  {
    id: 7,
    title: "Casa Condomínio Fechado",
    price: "R$ 1.200.000",
    additionalCosts: "+ condomínio e IPTU",
    address: "Alphaville Dom Pedro, Campinas - SP",
    image: "/img-default.jpg",
    saleType: "Venda",
    type: "Casa",
    attributes: "4 quartos • 3 banheiros • 200m²",
    badges: [{ type: "launch", label: "Lançamento" }],
    engagementCount: 18,
  },
  {
    id: 8,
    title: "Loft Moderno Vila Industrial",
    price: "R$ 1.900",
    priceUnit: "/mês",
    additionalCosts: "+ condomínio e IPTU",
    address: "Rua Industrial, 456 - Vila Industrial, Campinas - SP",
    image: "/img-default.jpg",
    saleType: "Locação",
    code: "00000000000000",
    type: "Loft",
    attributes: "1 ambiente • 1 banheiro • 45m²",
    isNew: true,
  },
  {
    id: 9,
    title: "Sobrado Jardim Chapadão",
    price: "R$ 650.000",
    additionalCosts: "+ condomínio e IPTU",
    address: "Rua das Flores, 890 - Jardim Chapadão, Campinas - SP",
    image: "/img-default.jpg",
    saleType: "Venda",
    code: "00000000000000",
    type: "Sobrado",
    attributes: "3 quartos • 2 banheiros • 150m²",
    engagementCount: 8,
  },
  {
    id: 10,
    title: "Apartamento Duplex Cambuí",
    price: "R$ 4.500",
    priceUnit: "/mês",
    additionalCosts: "+ condomínio e IPTU",
    address: "Av. José de Souza Campos, 1500 - Cambuí, Campinas - SP",
    image: "/img-default.jpg",
    saleType: "Locação",
    code: "00000000000000",
    type: "Duplex",
    attributes: "3 quartos • 3 banheiros • 120m²",
    badges: [{ type: "featured", label: "Destaque" }],
  },
  {
    id: 11,
    title: "Casa Térrea Nova Campinas",
    price: "R$ 890.000",
    additionalCosts: "+ condomínio e IPTU",
    address: "Rua Boa Vista, 234 - Nova Campinas, Campinas - SP",
    image: "/img-default.jpg",
    saleType: "Venda",
    type: "Casa",
    attributes: "3 quartos • 2 banheiros • 180m²",
    engagementCount: 15,
  },
  {
    id: 12,
    title: "Studio Compacto Bosque",
    price: "R$ 1.400",
    priceUnit: "/mês",
    additionalCosts: "+ condomínio e IPTU",
    address: "Rua do Bosque, 678 - Bosque de Campinas, Campinas - SP",
    image: "/img-default.jpg",
    saleType: "Locação",
    type: "Studio",
    code: "00000000000000",
    attributes: "1 quarto • 1 banheiro • 25m²",
    isNew: true,
    badges: [{ type: "partner", label: "HouseBit Studios" }],
  },
  {
    id: 13,
    title: "Cobertura Panorâmica Centro",
    price: "R$ 1.850.000",
    additionalCosts: "+ condomínio e IPTU",
    address: "Av. Francisco Glicério, 100 - Centro, Campinas - SP",
    image: "/img-default.jpg",
    saleType: "Venda",
    type: "Cobertura",
    code: "00000000000000",
    attributes: "4 quartos • 4 banheiros • 250m²",
    badges: [{ type: "featured", label: "Exclusivo" }],
    engagementCount: 25,
  },
  {
    id: 14,
    title: "Apartamento Familiar Ponte Preta",
    price: "R$ 2.100",
    priceUnit: "/mês",
    additionalCosts: "+ condomínio e IPTU",
    address: "Rua Ponte Preta, 567 - Ponte Preta, Campinas - SP",
    image: "/img-default.jpg",
    saleType: "Locação",
    type: "Apartamento",
    code: "00000000000000",
    attributes: "3 quartos • 2 banheiros • 85m²",
    engagementCount: 7,
  },
  {
    id: 15,
    title: "Casa em Condomínio Sousas",
    price: "R$ 750.000",
    additionalCosts: "+ condomínio e IPTU",
    address: "Condomínio Residencial Sousas, Campinas - SP",
    image: "/img-default.jpg",
    saleType: "Venda",
    type: "Casa",
    code: "00000000000000",
    attributes: "2 quartos • 2 banheiros • 110m²",
    isNew: true,
    engagementCount: 20,
  },
  {
    id: 16,
    title: "Apartamento Vista Parque",
    price: "R$ 3.800",
    priceUnit: "/mês",
    additionalCosts: "+ condomínio e IPTU",
    address: "Av. Andrade Neves, 2200 - Centro, Campinas - SP",
    image: "/img-default.jpg",
    saleType: "Locação",
    type: "Apartamento",
    code: "00000000000000",
    attributes: "3 quartos • 2 banheiros • 100m²",
    badges: [{ type: "price-drop", label: "Preço Reduzido" }],
  },
];
